<template>
    <div v-if="resObjects.length > 0" class="res-object-list">
        <div class="flex flex-col gap-2 max-h-full p-1">
            <div
                v-for="resObject in displayResObjects"
                :key="resObject.id"
                class="p-1 cursor-pointer hover:bg-surface-500 w-full rounded-md"
                @click="handleResObjectClick(resObject)"
            >
                <div class="font-medium text-sm">
                    {{ resObject.name }}
                </div>
                <div v-if="resObject.city || resObject.zipcode" class="text-xs mt-1">
                    {{ [resObject.city, resObject.zipcode].filter(Boolean).join(', ') }}
                </div>
                <div v-if="showLastUsed && resObject.lastUsed" class="text-xs mt-1">Last used: {{ formatDate(resObject.lastUsed) }}</div>
            </div>
        </div>
    </div>
    <div v-else class="flex align-items-center justify-content-center p-4 text-color-secondary">
        <i class="pi pi-info-circle mr-2" />
        <span>No resources available</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ResObject } from '@visma-real-estate-solutions/spring-editor-shared';

interface Props {
    resObjects: ResObject[];
    title?: string;
    showActiveOnly?: boolean;
    showLastUsed?: boolean;
}

interface Emits {
    (e: 'resObjectClick', resObject: ResObject): void;
}

const props = withDefaults(defineProps<Props>(), {
    title: 'Your Resources',
    showActiveOnly: true,
    showLastUsed: false,
});

const emit = defineEmits<Emits>();

const displayResObjects = computed(() => {
    if (props.showActiveOnly) {
        return props.resObjects.filter((obj) => obj.active);
    }
    return props.resObjects;
});

const handleResObjectClick = (resObject: ResObject) => {
    emit('resObjectClick', resObject);
};

const formatDate = (date: Date) => new Date(date).toLocaleDateString();
</script>
